import { useCallback } from 'react'

import { isClient } from '~/utils/helpers'

import useApp from '~/hooks/useApp'
import useScope from '~/hooks/useScope'
import useRouteContext from '~/hooks/useRouteContext'

import type * as Types from './types'

const useAnalytics: Types.UseAnalytics = () => {
    const app = useApp()
    const scope = useScope()

    const {
        NODE_ENV,
        GTM_TRACKING_ID
    } = useRouteContext()

    const event: Types.AnalyticsEventHandler = useCallback((event: string, payload: Record<string, unknown>) => {
        if (isClient && NODE_ENV !== 'development' && GTM_TRACKING_ID) {
            if (event) {
                window.dataLayer.push({
                    event: event,
                    scopes: scope.newspapers,
                    app_type: app.id,
                    ...payload
                })
            }
        }
    }, [
        GTM_TRACKING_ID,
        NODE_ENV,
        app.id,
        scope.newspapers
    ])

    return {
        event: event
    }
}

export default useAnalytics